(() => {
  function enhance() {
    document.querySelectorAll('[data-tw-content]').forEach(root => {
      if (root.dataset.twBound) return;
      root.dataset.twBound = 'true';
      root.querySelectorAll('.pf-bg-lazy').forEach(e=>e.classList.remove('pf-bg-lazy'));
      // Preserve the store's existing ShareThis configuration without PageFly initialization.
      if (root.querySelector('.sharethis-inline-share-buttons') && !document.querySelector('script[src^="https://platform-api.sharethis.com/js/sharethis.js"]')) {
        const share = document.createElement('script');share.async=true;
        share.src='https://platform-api.sharethis.com/js/sharethis.js#property=66b03d2a969157001920a62f&product=inline-share-buttons&source=shopify';
        document.head.append(share);
      }
      root.querySelectorAll('[data-tw-href]').forEach(element => {
        if (element.dataset.twAction === 'lightbox') {
          element.tabIndex = 0; element.setAttribute('role', 'button');
          const open = event => {
            event.preventDefault(); event.stopPropagation();
            let dialog = root.querySelector('.tw-content-dialog');
            if (!dialog) {
              dialog = document.createElement('dialog'); dialog.className = 'tw-content-dialog';
              dialog.setAttribute('aria-label', '画像の拡大表示');
              const close = document.createElement('button'); close.type = 'button'; close.textContent = '閉じる';
              close.addEventListener('click', () => dialog.close());
              dialog.append(close, document.createElement('img')); root.append(dialog);
              dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
            }
            const img = dialog.querySelector('img'); img.src = element.dataset.twHref; img.alt = element.alt || '';
            dialog.showModal();
          };
          element.addEventListener('click', open);
          element.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') open(e); });
        } else if (!element.closest('a') && element.tagName !== 'A') {
          element.tabIndex = 0; element.setAttribute('role', 'link');
          const follow = e => {
            e.preventDefault();
            const url = new URL(element.dataset.twHref, location.href);
            if (!['http:', 'https:'].includes(url.protocol)) return;
            if (element.dataset.target === '_blank') window.open(url.href, '_blank', 'noopener');
            else location.assign(url.href);
          };
          element.addEventListener('click', follow);
          element.addEventListener('keydown', e => { if (e.key === 'Enter') follow(e); });
        }
      });
      root.querySelectorAll('details').forEach(details => {
        details.addEventListener('toggle', () => {
          const summary = details.querySelector('summary'); if (summary) summary.dataset.active = String(details.open);
          const group = details.closest('[data-open-multiple="false"]');
          if (group && details.open) group.querySelectorAll('details').forEach(other => { if (other !== details) other.open = false; });
        });
      });
      root.querySelectorAll('.product-media2-inner').forEach(media => {
        media.classList.remove('product-media-loading');
        const main = [...media.querySelectorAll('.pf-slide-main-media')];
        const show = index => main.forEach((slide, i) => { slide.hidden = i !== index; });
        media.querySelectorAll('.pf-slide-list-media').forEach(thumbnail => {
          thumbnail.tabIndex = 0; thumbnail.setAttribute('role', 'button'); thumbnail.setAttribute('aria-label', '商品画像を切り替える');
          const select = () => { const index = main.findIndex(s => s.dataset.mediaId === thumbnail.dataset.imgId); if (index >= 0) show(index); };
          thumbnail.addEventListener('click', select);
          thumbnail.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') {e.preventDefault();select();} });
        });
        if (main.length) show(0);
      });
      root.querySelectorAll('[data-pf-type="Slideshow"]').forEach(slideshow => {
        const track = slideshow.querySelector('.pf-slider');
        const slides = track ? [...track.children].filter(x => x.classList.contains('pf-slide')) : [];
        if (!slides.length) return;
        slideshow.classList.add('tw-content-slideshow'); track.classList.add('tw-content-track');
        slides.forEach(s => s.classList.add('tw-content-slide'));
        let index = 0;
        const bar = document.createElement('div'); bar.className = 'tw-content-controls';
        const prev = document.createElement('button'), next = document.createElement('button'), status = document.createElement('span');
        prev.type = next.type = 'button'; prev.textContent = '前へ'; next.textContent = '次へ';
        status.setAttribute('aria-live', 'polite');
        const show = n => {index=(n+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==index);status.textContent=(index+1)+' / '+slides.length;};
        prev.addEventListener('click',()=>show(index-1));next.addEventListener('click',()=>show(index+1));
        let pointer;
        track.addEventListener('pointerdown',e=>pointer={x:e.clientX,y:e.clientY});
        track.addEventListener('pointerup',e=>{if(!pointer)return;const dx=e.clientX-pointer.x,dy=e.clientY-pointer.y;pointer=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))show(index+(dx<0?1:-1));});
        track.addEventListener('pointercancel',()=>pointer=null);
        bar.append(prev,status,next);slideshow.append(bar);show(0);
        if (slideshow.dataset.twAuto === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          let paused = false, hovering = false;
          const toggle = document.createElement('button');toggle.type='button';toggle.textContent='自動送りを停止';
          toggle.addEventListener('click',()=>{paused=!paused;toggle.textContent=paused?'自動送りを再開':'自動送りを停止';});bar.append(toggle);
          slideshow.addEventListener('mouseenter',()=>hovering=true);slideshow.addEventListener('mouseleave',()=>hovering=false);
          const timer=setInterval(()=>{
            if(!root.isConnected){clearInterval(timer);return;}
            if(!paused&&!document.hidden&&!(hovering&&slideshow.dataset.twHoverPause==='true')&&!slideshow.contains(document.activeElement))show(index+1);
          },Math.max(1000,Number(slideshow.dataset.twDelay)||3000));
        }
      });
    });
  }
  document.addEventListener('shopify:section:load', enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, {once: true}); else enhance();
})();
